// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4062":"9aedba38","5474":"9aedba38"}[chunkId] + ".chunk.css";
};